import '@docsearch/css'
// https://autocomplete-experimental.netlify.app/docs/docsearch/
import { DocSearch } from '@docsearch/react'
import DarkMode from '@/components/DarkMode'
import styles from '../styles/Search.module.css'

// note that all Algolia app ids and search API keys are
// public information, and are used client-side only.

export default function Search() {
  return (
    <>
      <div className={styles.topBar}>
        <DarkMode />
      </div>
      <div className={styles.course}>
        <h2>Check out my Cypress courses 🎓</h2>
        <div>
          <a href="/courses/network-testing" target="_self">
            Cypress Network Testing Exercises
          </a>
          ,{' '}
          <a href="/courses/cypress-plugins" target="_self">
            Cypress Plugins
          </a>
          ,{' '}
          <a href="/courses/swag-store" target="_self">
            Testing The Swag Store
          </a>
        </div>
      </div>

      <h1>Search Cypress Knowledge</h1>

      <section>
        <h2>Search across Gleb's Cypress blog posts</h2>
        <div>
          Search across more than 300+ blog posts from{' '}
          <a href="https://glebbahmutov.com/blog/tags/cypress/">
            glebbahmutov.com/blog/tags/cypress/
          </a>
        </div>
        <br />

        <DocSearch
          appId="7ALVH7RIND"
          apiKey="677d5b6f7727fe8b5b29bde0f831d605"
          indexName="Gleb Blog Cypress Posts"
          placeholder="Search Gleb's Cypress blog posts"
        />
      </section>

      <section>
        <h2>Search across Gleb's Cypress examples</h2>
        <div>
          Cypress command examples and recipes from{' '}
          <a href="https://glebbahmutov.com/cypress-examples">
            glebbahmutov.com/cypress-examples
          </a>{' '}
          with 600+ test examples.
        </div>
        <br />
        <DocSearch
          appId="48DTXR75RW"
          apiKey="d2cc2084df39806bdefb04f60f16e856"
          indexName="cypress-examples"
          placeholder="Search cypress-examples"
        />
      </section>

      <section>
        <h2>Search Gleb's Cypress videos </h2>
        <div>
          Search the playlist{' '}
          <a href="https://www.youtube.com/playlist?list=PLP9o9QNnQuAYYRpJzDNWpeuOVTwxmIxcI">
            Cypress Tips & Tricks
          </a>{' '}
          with 500+ videos.
        </div>
        <br />
        <DocSearch
          appId="WHPTTY4F1K"
          apiKey="84611c1a64bbc5b160e4b57d87ba1e89"
          indexName="videos"
          placeholder="Search Cypress Tips & Tricks videos"
        />
      </section>

      <section>
        <h2>
          Search my Cypress courses <span className={styles.badge}>New!</span>
        </h2>
        <div>
          Search the <a href="/courses">course lessons</a> content
        </div>
        <br />
        <DocSearch
          appId="1I3QBVLHX8"
          apiKey="ba4903b3be1708cde94afd6436ed739d"
          indexName="cypress_courses"
          placeholder="Search my Cypress courses"
        />
      </section>

      <section>
        <h2>Search Gleb's presentations</h2>
        <div>
          Search the presentation slides{' '}
          <a href="https://slides.com/bahmutov/">slides.com/bahmutov</a>
        </div>
        <br />
        <DocSearch
          appId="HLDS0F3LKH"
          apiKey="ebf859488b662851dd66eaef996b0875"
          indexName="slides"
          placeholder="Search slides.com/bahmutov"
        />
      </section>

      <section>
        <h2>Search Cypress documentation</h2>
        <div>
          Search the official Cypress documentation at{' '}
          <a href="https://docs.cypress.io/">docs.cypress.io/</a>
        </div>
        <br />
        <DocSearch
          appId="R9KDA5FMJB"
          apiKey="b4af59e23bc2fa05281af7dcf13fcae5"
          indexName="docs"
          placeholder="Search Cypress.io documentation"
        />
      </section>

      <footer className={styles.footer}>
        <p>
          Read how I scraped the blog posts in{' '}
          <a href="https://glebbahmutov.com/blog/scrape-static-site-with-algolia/">
            Scrape Static Site with Algolia
          </a>
          , slides in{' '}
          <a href="https://glebbahmutov.com/blog/scrape-slides/">
            Scrape Slides
          </a>
          .
        </p>
      </footer>
    </>
  )
}
